<template>
  <v-menu
    v-model='menuIsOpen'
    offset-y
    :close-on-content-click='false'
    min-width='undefined'
  >
    <template #activator="{ on, attrs }">
      <w-text-field
        ref="textfield"
        v-model='internalColorValueProxy'
        v-bind='$props'
        v-on='on'
        @click:clear='internalColorValueProxy = undefined'
      >
        <template #prepend-inner>
          <w-icon v-if='internalColorValueProxy == undefined'>
            $wColorNoSelection
          </w-icon>
          <w-icon
            v-else
            :color='internalColorValueProxy'
          >
            $wColorSelection
          </w-icon>
        </template>
      </w-text-field>
    </template>
    <v-sheet>
      <v-color-picker
        v-model='internalColorPickerValueProxy'
        :hide-canvas='hideCanvas'
        :hide-mode-switch='hideModeSwitch'
        :dot-size='dotSize'
        :show-swatches='showSwatches'
        :flat='flat'
        :mode='mode'
      />
      <div class='d-flex justify-center'>
        <w-btn
          :elevation='0'
          block
          @click='emitCurrentColorPickerColor'
        >
          {{ $t('Common.accept') }} 
        </w-btn>
      </div>
    </v-sheet>
  </v-menu>
</template>

<script>
// components
import WorkTextField from '@/components/global_components/forms/WorkTextField';
import { VColorPicker } from 'vuetify/lib';

// mixins
import isRequired from '@/mixins/component/is-required-mixin';
import pendingAble from '@/mixins/component/pending-able-mixin';

// helpers
import debounce from "lodash/debounce";

export default {
  name: 'WorkColorPicker',
  mixins: [isRequired, pendingAble],
  model: ['value'],
  props: {
    ...VColorPicker.options.props,
    hideCanvas: { type: Boolean, default: false },
    hideModeSwitch: { type: Boolean, default: true },
    hideSliders: { type: Boolean, default: true },
    flat: { type: Boolean, default: true },
    showSwatches: { type: Boolean, default: false },
    mode: { type: String, default: 'hexa' },
    dotSize: { type: [Number, String], default: 25 },
    ...WorkTextField.props,
    clearable: { type: Boolean, default: true },
  },
  data() {
    return {
      internalColorPickerValue: {},
      menuIsOpen: false,
    };
  },
  computed: {
    internalColorPickerValueProxy: {
      set: debounce(function(colorValue) {
        this.internalColorPickerValue = colorValue;
      }, 100),
      get () {
        return this.internalColorPickerValue;
      }
    },
    internalColorValueProxy: {
      set (newColorValue) {
        this.$emit('input', newColorValue);
      },
      get () {
        return this.value;
      }
    }
  },
  methods: {
    emitCurrentColorPickerColor() {
      this.menuIsOpen = false;
      this.$emit('input', this.internalColorPickerValue[this.mode]);
    },
    focus() {
      this.$refs.textfield.focus();
    }
  },
};
</script>
